module.exports = __webpack_public_path__ + "static/img/subway-01.baf8e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subway-01.png
// module id = 146
// module chunks = 0